import { render, staticRenderFns } from "./WholesaleStatisticsPage.vue?vue&type=template&id=564ad797"
import script from "./WholesaleStatisticsPage.vue?vue&type=script&lang=js"
export * from "./WholesaleStatisticsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports